import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, timer } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BuildDetails } from './build-details';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class UpToDateBuildService {
    private buildIsUpToDateSubject = new BehaviorSubject<boolean>(true);
    private buildNumberAtStart: string;
    private newBuildNumber: string;

    constructor(
        private httpClient: HttpClient,
        private notificationsService: NotificationsService,
        private translateService: TranslateService,
    ) {
        this.pollForBuildNumber();
    }

    public get buildIsUpToDate(): Observable<boolean> {
        return this.buildIsUpToDateSubject;
    }

    private pollForBuildNumber() {
        const pollInterval = 60000;

        const httpOptions = {
            headers: new HttpHeaders({
                'Cache-Control': 'no-cache',
            }),
        };

        const subscription = timer(0, pollInterval).subscribe(() => {
            this.httpClient.get<BuildDetails>('assets/build-details.json', httpOptions).subscribe((response) => {
                if (!this.buildNumberAtStart) {
                    this.buildNumberAtStart = response.buildNumber;
                }
                this.newBuildNumber = response.buildNumber;

                if (this.buildNumberAtStart !== this.newBuildNumber) {
                    this.notificationsService.html(
                        '<span class="sn-title">' +
                            this.translateService.instant('Warning!') +
                            '</span><br>' +
                            '<span>' +
                            this.translateService.instant('New version of Inbox is available. Please,') +
                            ' </span>' +
                            '<a href="' +
                            window.location.href +
                            '">' +
                            this.translateService.instant('refresh the page') +
                            '</a>',
                        NotificationType.Warn,
                        {
                            timeOut: 0,
                        },
                        'warn',
                    );

                    this.buildIsUpToDateSubject.next(false);
                    subscription.unsubscribe();
                }
            });
        });
    }
}
